import { Component, Input, OnInit } from '@angular/core';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';


@Component({
  selector: 'app-order-log-drawer',
  templateUrl: './order-log-drawer.component.html'
})
export class OrderLogDrawerComponent implements OnInit {

  selectedLog: any;
  buttonLoading = false;
  Orders:any;
  @Input()orderId:any;
  constructor(private drawerRef: NzDrawerRef<string>) {
  }
  ngOnInit() {

  }
  // To Stop loading and close drawer after save
  saveLogs($event) {
    this.buttonLoading = false;
    this.selectedLog = $event;
    this.drawerRef.close($event);
  }
  // To Close drawer
  close(): void {
    this.drawerRef.close(this.selectedLog);
  }

}
